import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-game" }
const _hoisted_2 = { class: "content" }

import Tag from "./detail/tag.vue";
import Region from "./detail/region.vue";
import Language from "./detail/language.vue";
import Manufacturer from "./detail/manufacturer.vue";
import Media from "./detail/media.vue";
import Release from "./detail/release.vue";
import Franchise from "./detail/franchise.vue";
import Gender from "./detail/gender.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'details',
  props: {
    gameId: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Tag, { "game-id": __props.gameId }, null, 8, ["game-id"]),
      _createVNode(Region, { "game-id": __props.gameId }, null, 8, ["game-id"])
    ])
  ]))
}
}

})